import { Injectable } from '@angular/core';
import { environment } from '../../../../environments/environment';
import { HttpHeaders, HttpClient } from '@angular/common/http';

@Injectable({
  providedIn: 'root'
})
export class CentersCentersDaoService {

  private BASE_URL = environment.apiURL;
  private OPTIONS = {
    headers: new HttpHeaders({
      'Content-Type': 'application/json; charset=UTF-8'
    })
  };

  constructor(private http: HttpClient) { }

  public getCenters(context, lang, udid) {
    const options = {};
    Object.assign(options, this.OPTIONS);
    options['headers'] = options['headers'].append('context', context);
    options['headers'] = options['headers'].append('lang', lang);
    options['headers'] = options['headers'].append('udid', udid);
    const item = { };
    return this.http.post(this.BASE_URL + 'private/v2.0/centerMaintenance/ws_getCenterList', item, options);
  }

  public getCenterInfo(context, lang, udid, internalId) {
    const options = {};
    Object.assign(options, this.OPTIONS);
    options['headers'] = options['headers'].append('context', context);
    options['headers'] = options['headers'].append('lang', lang);
    options['headers'] = options['headers'].append('udid', udid);
    const item = { internalId };
    return this.http.post(this.BASE_URL + 'private/v2.0/centerMaintenance/ws_getCenterDetails', item, options);
  }

  public getCenterDeleteImpact(context, lang, udid, internalId) {
    const options = {};
    Object.assign(options, this.OPTIONS);
    options['headers'] = options['headers'].append('context', context);
    options['headers'] = options['headers'].append('lang', lang);
    options['headers'] = options['headers'].append('udid', udid);
    return this.http.post(this.BASE_URL + 'private/v2.0/centerMaintenance/ws_getCenterDeleteImpact', { internalId }, options);
  }

  public deleteCenter(context, lang, udid, internalId) {
    const options = {};
    Object.assign(options, this.OPTIONS);
    options['headers'] = options['headers'].append('context', context);
    options['headers'] = options['headers'].append('lang', lang);
    options['headers'] = options['headers'].append('udid', udid);
    return this.http.post(this.BASE_URL + 'private/v2.0/centerMaintenance/ws_deleteCenter', { internalId }, options);
  }

  public addNewCenter(context, lang, udid, visible, imageSource, name, cif, fiscalName, fiscalAddress, street, zipCode, city, province, region, country, gpsLatitude, gpsLongitude, faxNumber, phoneNumber, email, centerContact, centerTypeInternalId, code, timeZone, currency) {
    const options = {};
    Object.assign(options, this.OPTIONS);
    options['headers'] = options['headers'].append('context', context);
    options['headers'] = options['headers'].append('lang', lang);
    options['headers'] = options['headers'].append('udid', udid);
    const item = { visible, imageSource, name, cif, fiscalName, fiscalAddress, street, zipCode, city, province, region, country, gpsLatitude, gpsLongitude, faxNumber, phoneNumber, email, centerContact, centerTypeInternalId, code, timeZone, currency };
    return this.http.post(this.BASE_URL + 'private/v2.0/centerMaintenance/ws_storeCenter', item, options);
  }
  public updateCenterInfo(context, lang, udid, internalId, visible, name, cif, fiscalName, fiscalAddress, street, zipCode, city, province, region, country, gpsLatitude, gpsLongitude, faxNumber, phoneNumber, email, centerContact, centerTypeInternalId, timeZone, currencyInternalId) {
    const options = {};
    Object.assign(options, this.OPTIONS);
    options['headers'] = options['headers'].append('context', context);
    options['headers'] = options['headers'].append('lang', lang);
    options['headers'] = options['headers'].append('udid', udid);
    const item = { internalId, visible, name, cif, fiscalName, fiscalAddress, street, zipCode, city, province, region, country, gpsLatitude, gpsLongitude, faxNumber, phoneNumber, email, centerContact, centerTypeInternalId, timeZone, currencyInternalId };
    return this.http.post(this.BASE_URL + 'private/v2.0/centerMaintenance/ws_updateCenter', item, options);
  }
  public updateCenterRadius(context, lang, udid, internalId, maxRadius) {
    const options = {};
    Object.assign(options, this.OPTIONS);
    options['headers'] = options['headers'].append('context', context);
    options['headers'] = options['headers'].append('lang', lang);
    options['headers'] = options['headers'].append('udid', udid);
    const item = { internalId, maxRadius };
    return this.http.post(this.BASE_URL + 'private/v2.0/centerMaintenance/ws_updateCenterRadius', item, options);
  }
  public updateCenterDefaultLanguage(context, lang, udid, centerInternalId, defaultLanguageInternalId) {
    const options = {};
    Object.assign(options, this.OPTIONS);
    options['headers'] = options['headers'].append('context', context);
    options['headers'] = options['headers'].append('lang', lang);
    options['headers'] = options['headers'].append('udid', udid);
    const item = { centerInternalId, defaultLanguageInternalId };
    return this.http.put(this.BASE_URL + 'private/v2.0/centerMaintenance/defaultLanguage', item, options);
  }
  public getCenterScheduleList(context, lang, udid, internalId) {
    const options = {};
    Object.assign(options, this.OPTIONS);
    options['headers'] = options['headers'].append('context', context);
    options['headers'] = options['headers'].append('lang', lang);
    options['headers'] = options['headers'].append('udid', udid);
    const item = { internalId };
    return this.http.post(this.BASE_URL + 'private/v2.0/centerMaintenance/ws_getCenterCalendarList', item, options);
  }
  public getCenterScheduleInfo(context, lang, udid, internalId) {
    const options = {};
    Object.assign(options, this.OPTIONS);
    options['headers'] = options['headers'].append('context', context);
    options['headers'] = options['headers'].append('lang', lang);
    options['headers'] = options['headers'].append('udid', udid);
    const item = { internalId };
    return this.http.post(this.BASE_URL + 'private/v2.0/centerMaintenance/ws_getCenterCalendar', item, options);
  }
  public addNewCenterSchedule(context, lang, udid, relatedEntityInternalId, mon, tue, wed, thu, fri, sat, sun, openTimeMorning, closeTimeMorning, openTimeAfternoon, closeTimeAfternoon, startDate, endDate, openService, commentNote, timeZone) {
    const options = {};
    Object.assign(options, this.OPTIONS);
    options['headers'] = options['headers'].append('context', context);
    options['headers'] = options['headers'].append('lang', lang);
    options['headers'] = options['headers'].append('udid', udid);
    const item = { relatedEntityInternalId, mon, tue, wed, thu, fri, sat, sun, openTimeMorning, closeTimeMorning, openTimeAfternoon, closeTimeAfternoon, startDate, endDate, openService, commentNote, timeZone };
    return this.http.post(this.BASE_URL + 'private/v2.0/centerMaintenance/ws_saveCenterCalendar', item, options);
  }
  public updateCenterSchedule(context, lang, udid, internalId, relatedEntityInternalId, mon, tue, wed, thu, fri, sat, sun, openTimeMorning, closeTimeMorning, openTimeAfternoon, closeTimeAfternoon, startDate, endDate, openService, commentNote, timeZone) {
    const options = {};
    Object.assign(options, this.OPTIONS);
    options['headers'] = options['headers'].append('context', context);
    options['headers'] = options['headers'].append('lang', lang);
    options['headers'] = options['headers'].append('udid', udid);
    const item = { internalId, relatedEntityInternalId, mon, tue, wed, thu, fri, sat, sun, openTimeMorning, closeTimeMorning, openTimeAfternoon, closeTimeAfternoon, startDate, endDate, openService, commentNote, timeZone };
    return this.http.post(this.BASE_URL + 'private/v2.0/centerMaintenance/ws_saveCenterCalendar', item, options);
  }
  public deleteCenterSchedule(context, lang, udid, internalId, relatedEntityInternalId) {
    const options = {};
    Object.assign(options, this.OPTIONS);
    options['headers'] = options['headers'].append('context', context);
    options['headers'] = options['headers'].append('lang', lang);
    options['headers'] = options['headers'].append('udid', udid);
    const item = { internalId, relatedEntityInternalId };
    return this.http.post(this.BASE_URL + 'private/v2.0/centerMaintenance/ws_deleteCenterCalendar', item, options);
  }

  public getCenterConfigurationInfo(context, lang, udid, internalId) {
    const options = {};
    Object.assign(options, this.OPTIONS);
    options['headers'] = options['headers'].append('context', context);
    options['headers'] = options['headers'].append('lang', lang);
    options['headers'] = options['headers'].append('udid', udid);
    const item = { internalId };
    return this.http.post(this.BASE_URL + 'private/v2.0/centerMaintenance/ws_getCenterConfigurationInfo', item, options);
  }

  public getCenterTypes(context, lang, udid) {
    const options = {};
    Object.assign(options, this.OPTIONS);
    options['headers'] = options['headers'].append('context', context);
    options['headers'] = options['headers'].append('lang', lang);
    options['headers'] = options['headers'].append('udid', udid);
    const item = { };
    return this.http.post(this.BASE_URL + 'private/v2.0/centerMaintenance/ws_getCenterTypeList', item, options);
  }

  public getCenterCurrencies(context, lang, udid) {
    const options = {};
    Object.assign(options, this.OPTIONS);
    options['headers'] = options['headers'].append('context', context);
    options['headers'] = options['headers'].append('lang', lang);
    options['headers'] = options['headers'].append('udid', udid);
    return this.http.get(this.BASE_URL + 'private/v2.0/centerMaintenance/currency/all', options);
  }

  public saveCenterLanguages(context, lang, udid, centerInternalId, languageInternalIdList) {
    const options = {};
    Object.assign(options, this.OPTIONS);
    options['headers'] = options['headers'].append('context', context);
    options['headers'] = options['headers'].append('lang', lang);
    options['headers'] = options['headers'].append('udid', udid);
    const item = { centerInternalId, languageInternalIdList };
    return this.http.post(this.BASE_URL + 'private/v2.0/centerMaintenance/ws_saveCenterLanguage', item, options);
  }

  public updateInfoAlert(context, lang, udid, centerInternalId, infoAlert) {
    const options = {};
    Object.assign(options, this.OPTIONS);
    options['headers'] = options['headers'].append('context', context);
    options['headers'] = options['headers'].append('lang', lang);
    options['headers'] = options['headers'].append('udid', udid);
    const item = { centerInternalId, infoAlert };
    return this.http.post(this.BASE_URL + 'private/v2.0/centerMaintenance/ws_updateInfoAlertField', item, options);
  }

  public updateShowOnline(context, lang, udid, centerInternalId, online) {
    const options = {};
    Object.assign(options, this.OPTIONS);
    options['headers'] = options['headers'].append('context', context);
    options['headers'] = options['headers'].append('lang', lang);
    options['headers'] = options['headers'].append('udid', udid);
    const item = { centerInternalId, online };
    return this.http.post(this.BASE_URL + 'private/v2.0/centerMaintenance/ws_updateOnlineField', item, options);
  }

  public updateImageCenter(context, lang, udid, internalId, imageUrl, size) {
    const options = {};
    Object.assign(options, this.OPTIONS);
    options['headers'] = options['headers'].append('context', context);
    options['headers'] = options['headers'].append('lang', lang);
    options['headers'] = options['headers'].append('udid', udid);
    const item = { internalId, imageUrl, size};
    return this.http.post(this.BASE_URL + 'private/v2.0/centerMaintenance/ws_updateImageCenter', item, options);
  }

  public getCenterExistingSchedules(context, lang, udid, internalId) {
    const options = {};
    Object.assign(options, this.OPTIONS);
    options['headers'] = options['headers'].append('context', context);
    options['headers'] = options['headers'].append('lang', lang);
    options['headers'] = options['headers'].append('udid', udid);
    const item = { internalId };
    return this.http.post(this.BASE_URL + 'private/v2.0/calendar/list', item, options);
  }

  public linkExistingCenterSchedule(context, lang, udid, internalId, relatedEntityInternalId) {
    const options = {};
    Object.assign(options, this.OPTIONS);
    options['headers'] = options['headers'].append('context', context);
    options['headers'] = options['headers'].append('lang', lang);
    options['headers'] = options['headers'].append('udid', udid);
    const item = { internalId, relatedEntityInternalId };
    return this.http.post(this.BASE_URL + 'private/v2.0/centerMaintenance/ws_linkCenterCalendar', item, options);
  }

  public getIotDevices(context, lang, udid, centerInternalId) {
    const options = {};
    Object.assign(options, this.OPTIONS);
    options['headers'] = options['headers'].append('context', context);
    options['headers'] = options['headers'].append('lang', lang);
    options['headers'] = options['headers'].append('udid', udid);
    const item = { centerInternalId };
    options['params'] = item;
    return this.http.get(this.BASE_URL + 'private/v2.0/centerMaintenance/iotDevices', options);
  }
  
}
